import { Carousel as UICarousel, type CarouselProps } from '@jagad/ui';
import { useTranslation } from 'react-i18next';

type Props = Omit<CarouselProps, 'slideAriaLabel'>;

const Carousel = (props: Props) => {
  const { t } = useTranslation();
  return (
    <UICarousel
      {...props}
      slideAriaLabel={t('components.carousel.slideAriaLabel')}
    />
  );
};

export default Carousel;
